import { render } from "./RoomsList.vue?vue&type=template&id=64cafea0&scoped=true"
import script from "./RoomsList.vue?vue&type=script&lang=js"
export * from "./RoomsList.vue?vue&type=script&lang=js"

import "./RoomsList.vue?vue&type=style&index=0&id=64cafea0&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cafea0"]])

export default __exports__